import handlebars from "handlebars";
import { generateComplianceTemplate } from "../templates/complianceTemplate";

interface ComplianceData {
    complianceType?: string;
    complianceTypeComment?: string;
}

export const compileComplianceTemplate = (complianceData: ComplianceData): string => {
    const compileTemplate = handlebars.compile(generateComplianceTemplate);

    const transformedData = {
        complianceType: complianceData?.complianceType || '',
        complianceTypeComment: complianceData?.complianceTypeComment || ''
    };

    return compileTemplate(transformedData);
};